<script setup lang="ts">
import NewsCard from '@/components/News/NewsCard.vue'

import type { SlugNews } from '@@/server/types/common'

type Props = {
  newsList: SlugNews[] | undefined
  countPages?: number
  currentPage?: number
  isLight?: boolean
  withImage?: boolean
}

type Emits = {
  (fn: 'update:model-value', page: number): void
}

withDefaults(defineProps<Props>(), {
  countPages: 0,
  currentPage: 1,
})

const emit = defineEmits<Emits>()

const onChangeCurrentPage = (page: number) => emit('update:model-value', page)
</script>

<template>
  <div
    id="newsListContainer"
    class="news-list-container"
    data-test-id="news-list-container"
  >
    <div class="news-list-container__list" data-test-id="news-list">
      <nuxt-link
        v-for="news in newsList"
        :key="news.slug"
        :to="`/news/${news.slug}/`"
        class="news-list-container__news-link"
        data-test-id="news-link"
      >
        <news-card
          class="news-list-container__card"
          :news="news"
          :is-light="isLight"
          :with-image="withImage"
          data-test-id="news-card"
        />
      </nuxt-link>
    </div>

    <the-pagination
      v-if="countPages"
      class="news-list-container__pagination"
      :model-value="currentPage"
      :total-pages="countPages"
      data-test-id="news-pagination"
      @update:model-value="onChangeCurrentPage"
    />
  </div>
</template>

<style scoped lang="scss">
.news-list-container {
  padding-bottom: 120px;

  &__list {
    display: grid;
    grid-template-columns: 100%;
    gap: 20px;
  }

  &__news-link {
    height: max-content;
    transition: 0.2s ease-in;

    &:hover {
      cursor: pointer;
      transform: translateY(5px);
    }
  }

  &__card {
    width: unset !important;
  }

  &__pagination {
    margin-top: 60px;
  }

  @include media($bp-tablet) {
    &__list {
      grid-template-columns: repeat(
        2,
        calc((100% - 40px) / 2)
      ); // ширина карточки в 2 колонки с учетом gap: 20px;
      gap: 20px;
    }
  }

  @include media($bp-desktop-mini) {
    &__list {
      grid-template-columns: repeat(
        3,
        calc((100% - 72px) / 3)
      ); // ширина карточки в 3 колонки с учетом column-gap: 36px;
      row-gap: 30px;
      column-gap: 36px;
    }

    &__pagination {
      margin-top: 80px;
    }
  }
}
</style>
